import createSelectors from './createSelectors';
import NoticeBoard from '../models/NoticeBoard';

const Select = createSelectors(NoticeBoard, {});

export default Select;
